import { SVGProps } from "react";

interface StarSolidIconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
}

export default function StarSolidIcon(props: StarSolidIconProps) {
  const { height = 19, width = 20, fill = "#ffffff", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.12579 0.521664C9.35177 -0.17384 10.3357 -0.173841 10.5617 0.521663L12.3684 6.08218C12.4695 6.39322 12.7593 6.60381 13.0864 6.60381H18.9331C19.6644 6.60381 19.9684 7.5396 19.3768 7.96945L14.6467 11.406C14.3821 11.5983 14.2714 11.939 14.3725 12.25L16.1792 17.8106C16.4052 18.5061 15.6092 19.0844 15.0175 18.6546L10.2875 15.218C10.0229 15.0258 9.66461 15.0258 9.40003 15.218L4.66997 18.6546C4.07834 19.0844 3.2823 18.5061 3.50829 17.8106L5.31501 12.25C5.41607 11.939 5.30536 11.5983 5.04077 11.406L0.310715 7.96945C-0.280916 7.5396 0.0231414 6.60381 0.754438 6.60381H6.60111C6.92815 6.60381 7.21801 6.39322 7.31907 6.08218L9.12579 0.521664Z"
        fill={fill}
      />
    </svg>
  );
}
